import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

const R = Resources.Portfolio.List.DeleteDocumentDialog;

type Props = {
	open: boolean;
	documentTitle: string;
	onClose: () => void;
	onConfirm: () => void;
};

export const DeleteDocumentDrawer: FC<Props> = ({
	open,
	documentTitle,
	onClose,
	onConfirm,
}) => {
	const { palette, spacingTokens } = useTheme();
	const { t } = useResource();

	return (
		<MyPlannDrawer open={open} onClose={onClose} title={t(R.title)} grabber>
			<Box px={spacingTokens.lg} pb={spacingTokens.lg}>
				<Typography variant="body2" color={palette.grey[500]}>
					{t(R.description, { documentName: documentTitle })}
				</Typography>
				<Stack mt={spacingTokens.lg} gap={spacingTokens.xs}>
					<Button variant="primary" onClick={onConfirm}>
						{t(R.confirm)}
					</Button>
					<Button variant="ghost" onClick={onClose}>
						{t(R.cancel)}
					</Button>
				</Stack>
			</Box>
		</MyPlannDrawer>
	);
};
